import { useEffect, useState } from "react";

import { Panes } from "dev";
import { useLocalSearchParams } from "expo-router";

import StatusScreen, {
  TrackingHistoryCard,
  TrackingSubstatusCard,
} from "../[uuid]";
import { MockDeliveryStatusProvider } from "@/src/contexts/delivery-status-context";
import { fetchDeliveryStatus } from "@/src/services/dev";
import { DeliveryStatus } from "@/src/types";

export default function SingleExample() {
  const { uuid, status_at } = useLocalSearchParams<{
    uuid: string;
    status_at?: string;
  }>();
  const [deliveryStatus, setDeliveryStatus] = useState<DeliveryStatus | null>();

  useEffect(() => {
    fetchDeliveryStatus({ uuid, tstamp: status_at }).then((s) =>
      setDeliveryStatus(s)
    );
  });

  if (!deliveryStatus) return null;

  return (
    <MockDeliveryStatusProvider deliveryStatus={deliveryStatus}>
      <h1>Single Example</h1>
      <p>UUID: {uuid}</p>
      <p>Status at: {status_at}</p>
      <Panes>
        <pre>{JSON.stringify(deliveryStatus, null, 2)}</pre>

        <TrackingHistoryCard />

        <TrackingSubstatusCard />

        <StatusScreen />
      </Panes>
    </MockDeliveryStatusProvider>
  );
}
